export default {
  props: [
    'showModal',
    'message'
  ],
  data () {
    return {
      isConfirmButtonLoading: false
    }
  },
  methods: {
    confirm () {
      this.isConfirmButtonLoading = true
      this.$emit('emit-confirm')
    },
    cancel () {
      this.$emit('emit-cancel')
    }
  }
}
